<template>
  <div class="brandValues-body">
    <div class="value-body">
      <div class="value-wrapper">
        <div class="title">
          Authentic Engagement,<br />
          Not Ads
        </div>
        <div class="text">
          Traditional social media ads rely on algorithms that prioritize
          platform profits over authentic brand connections. Wecobi empowers
          brands to connect with customers through direct engagement, creating a
          network of genuine, trusted recommendations. Unlike impersonal ads,
          Wecobi leverages <span>word-of-mouth marketing</span>—proven to be far
          more effective, with <span>81% of consumers</span> trusting the advice
          of friends over business ads.
        </div>
      </div>
      <div class="line"></div>
      <div class="value-wrapper">
        <div class="title">
          Reward Your Customers, <br />
          Not Corporations
        </div>
        <div class="text">
          Instead of spending massive amounts on paid ads, Wecobi allows brands
          to incentivize customers to share products with their friends,
          generating organic growth and real customer loyalty. This approach not
          only <span>lowers acquisition costs</span> but also ensures that the
          financial benefits are shared directly with your most loyal customers,
          building stronger, more sustainable relationships.
        </div>
      </div>
    </div>
    <div class="rectangle"></div>
    <div class="value-body">
      <div class="value-wrapper">
        <div class="title">More Effective Marketing</div>
        <div class="text">
          Social media ads are becoming less effective due to ad fatigue and
          widespread use of ad-blockers. Wecobi offers a refreshing alternative
          by bypassing these barriers, utilizing customer-driven sharing and
          direct referrals to ensure your brand gets in front of highly engaged,
          relevant audiences <span>without wasting ad spend</span> on
          uninterested viewers.
        </div>
      </div>
      <div class="line"></div>
      <div class="value-wrapper">
        <div class="title">
          Sustainability and <br />
          Purpose-Driven Growth
        </div>
        <div class="text">
          As brands seek more purpose-driven marketing, Wecobi aligns with
          consumer values by promoting sustainability and conscious consumption.
          This approach not only reduces waste but also builds trust and
          <span>long-term loyalty</span>, creating a positive cycle of growth.
        </div>
      </div>
    </div>
  </div>
  <div class="brandValues-body-mobile">
    <div class="value-wrapper-mobile">
      <div class="title">
        Authentic Engagement,<br />
        Not Ads
      </div>
      <div class="text">
        Traditional social media ads rely on algorithms that prioritize platform
        profits over authentic brand connections. Wecobi empowers brands to
        connect with customers through direct engagement, creating a network of
        genuine, trusted recommendations. Unlike impersonal ads, Wecobi
        leverages <span>word-of-mouth marketing</span>—proven to be far more
        effective, with <span>81% of consumers</span> trusting the advice of
        friends over business ads.
      </div>
    </div>
    <div class="rectangle"></div>
    <div class="value-wrapper-mobile">
      <div class="title">
        Reward Your Customers, <br />
        Not Corporations
      </div>
      <div class="text">
        Instead of spending massive amounts on paid ads, Wecobi allows brands to
        incentivize customers to share products with their friends, generating
        organic growth and real customer loyalty. This approach not only
        <span>lowers acquisition costs</span> but also ensures that the
        financial benefits are shared directly with your most loyal customers,
        building stronger, more sustainable relationships.
      </div>
    </div>
    <div class="rectangle"></div>
    <div class="value-wrapper-mobile">
      <div class="title">More Effective Marketing</div>
      <div class="text">
        Social media ads are becoming less effective due to ad fatigue and
        widespread use of ad-blockers. Wecobi offers a refreshing alternative by
        bypassing these barriers, utilizing customer-driven sharing and direct
        referrals to ensure your brand gets in front of highly engaged, relevant
        audiences <span>without wasting ad spend</span> on uninterested viewers.
      </div>
    </div>
    <div class="rectangle"></div>
    <div class="value-wrapper-mobile">
      <div class="title">
        Sustainability and <br />
        Purpose-Driven Growth
      </div>
      <div class="text">
        As brands seek more purpose-driven marketing, Wecobi aligns with
        consumer values by promoting sustainability and conscious consumption.
        This approach not only reduces waste but also builds trust and
        <span>long-term loyalty</span>, creating a positive cycle of growth.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandValues",
  components: {},
};
</script>

<style scoped>
.brandValues-body {
  width: 100%;
  height: fit-content;
  background-color: #f7f7fa;
  border-radius: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 60px;
  padding: 60px 90px;
}

.brandValues-body-mobile {
  width: 100%;
  height: fit-content;
  background-color: #f7f7fa;
  border-radius: 20px;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  gap: 40px;
  padding: 60px;
}
.value-body {
  display: flex;
  justify-content: space-between;
  gap: 80px;
}
.value-wrapper {
  max-width: 659px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
}
.text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
.line {
  width: 2px;
  height: 193px;
  background-color: #f493a3;
}
.rectangle {
  height: 2px;
  width: 100%;
  background: linear-gradient(to left, #f98140 28%, #eb4dbf 72%);
}
span {
  font-weight: 700;
}

@media (max-width: 1500px) {
  .brandValues-body {
    padding: 60px 80px;
    gap: 40px;
  }
  .value-wrapper {
    max-width: 465px;
  }
  .value-body {
    gap: 60px;
  }
}
@media (max-width: 1200px) {
  .value-wrapper {
    max-width: 337px;
  }
  .line {
    height: 250px;
  }
}
@media (max-width: 1024px) {
  .brandValues-body {
    padding: 60px 60px;
  }
  .value-body {
    gap: 40px;
  }
  .title {
    font-size: 20px;
  }
  .value-wrapper {
    max-width: 100%;
  }
}

@media (max-width: 900px) {
  .brandValues-body {
    display: none;
  }
  .brandValues-body-mobile {
    display: flex;
  }
  .value-wrapper-mobile {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

@media (max-width: 431px) {
  .brandValues-body-mobile {
    padding: 60px 30px;
  }
  .text {
    font-size: 12px;
  }
}
</style>
